import { BarChartConfig } from "../config/BarChartConfig";
import { ChartTypeConfig } from "../config/ChartTypeConfig";
import { ColumnChartConfig } from "../config/ColumnChartConfig";
import { DoughnutChartConfig } from "../config/DoughnutChartConfig";
import { FunnelChartConfig } from "../config/FunnelChartConfig";
import { GaugeChartConfig } from "../config/GaugeChartConfig";
import { LineChartConfig } from "../config/LineChartConfig";
import { PieChartConfig } from "../config/PieChartConfig";
import { RadarChartConfig } from "../config/RadarChartConfig";
import { ScatterChartConfig } from "../config/ScatterChartConfig";
import { BasicChart, SeriesOption } from "./models";
import { SeriesType } from "./SeriesType";


export class ChartFactory {
  /**
   * Returns the chart config object for the given type and data
   */
  static createChartOptions(
    type: SeriesType,
    categories: string[],
    seriesData: SeriesOption[] | any[],
    colors: string[],
    totalValue?: number
  ): Partial<BasicChart> {
    const config = this.getChartTypeConfig(type);
    return config.getConfig(categories, seriesData, colors, totalValue);
  }

  /**
   * Returns a concrete config class that handles styling for the specific chart type
   */
  private static getChartTypeConfig(type: SeriesType): ChartTypeConfig {
    switch (type) {
      case SeriesType.Line:
        return new LineChartConfig();
      case SeriesType.Bar:
        return new BarChartConfig();
      case SeriesType.Column:
        return new ColumnChartConfig();
      case SeriesType.Pie:
        return new PieChartConfig();
      case SeriesType.Radar:
        return new RadarChartConfig();
      case SeriesType.Funnel:
        return new FunnelChartConfig();
      case SeriesType.Gauge:
        return new GaugeChartConfig();
      case SeriesType.Scatter:
        return new ScatterChartConfig();
      case SeriesType.Doughnut:
        return new DoughnutChartConfig();

      default:
        throw new Error(`Chart type '${type}' is not supported.`);
    }
  }
}
